module.exports = __webpack_public_path__ + "media/images/groupphasebet__sample@2x-aebd8ea33b620331f1364d844f2c6abb.png";